<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Lớp học của tôi
        .clearfix
      div.card.box-classes-me(v-if="lstPCs && lstPCs.length > 0")
        .box-info-pc(v-for="(item, index) in lstPCs" v-if="item.private_community")
          Item(:item="item" @unPinPC="unPinPC" :key="increment" v-on:onRemovePC="onRemovePC" v-on:resetPopover="resetPopover" :keyPopover="keyPopover" :keyActive="keyActive")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import Item from '../ClassesMe/item'
export default {
  components: {
    Item,
    MdNotification
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      lstPCs: [],
      loader: null,
      increment: 0,
      keyActive: '',
      keyPopover: false
    }
  },
  async mounted () {
    if (this.$route.params.reload === 1) {
      this.$router.go(0)
    }
    await this.autoRefresh()
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    async changeUnPinPC(item, unPin, isRender = false) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id}
      }
      var objInput = {
        un_pin: unPin
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput},
        update: (store, { data: { update_pc_user } }) => {
          if (update_pc_user.affected_rows) {
            this.loader.hide()
            this.$modal.hide('dialog')
            var index = this.lstPCs.findIndex(function(obj) { return obj.pc_id === item.pc_id })
            this.lstPCs[index].un_pin = unPin
            if (isRender) {
              this.sortRefresh()
            }
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      this.increment++
    },
    async unPinPC(item, unPin) {
      // neu chuyen sang ghim
      if (unPin === 2) {
        // kiem tra xem co pc nao khac duoc ghim khong
        var returnPin = this.lstPCs.filter(a => a.un_pin === 2 && a.pc_id !== item.pc_id)
        // neu co pc khac đang ghim
        if (returnPin && returnPin.length > 0) {
          this.$modal.show('dialog', {
            title: 'Xác nhận',
            text: 'Nội dung khác đang được ghim, bạn muốn ghim nội dung này?',
            class: 'col-md-6 col-12 box-popup-confirm',
            buttons: [
              {
                title: 'Xác nhận',
                default: true,
                class: 'btn btn-primary confirm-delete-dialog',
                handler: async () => {
                  await this.changeUnPinPC(returnPin[0], 1)
                  await this.changeUnPinPC(item, unPin, true)
                }
              },
              {
                title: 'Hủy yêu cầu',
                class: 'btn btn-primary cancel-delete-dialog'
              }
            ]
          })
        } else {
          await this.changeUnPinPC(item, unPin, true)
        }
      } else {
        await this.changeUnPinPC(item, unPin, true)
      }
    },
    async autoRefresh() {
      var variables = {
        where: {
          user_id: {'_eq': this.$store.getters.user},
          is_delete: {'_eq': false}
        },
        order_by: {
          un_pin: 'desc',
          created_at: 'desc'
        }
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_PC_USER_JOIN_STUDENT),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      if (data && data !== null) {
        this.lstPCs = []
        var listPCData = data.pc_user
        listPCData = [...new Map(listPCData.map(item =>
        [item['pc_id'], item])).values()]
        this.lstPCs = listPCData
      }
    },
    sortRefresh() {
      this.lstPCs.sort(this.compare)
    },
    compare(a, b) {
      const pinA = a.un_pin
      const pinB = b.un_pin
      let comparison = 0
      if (pinA > pinB) {
        comparison = -2
      } else if (pinA < pinB) {
        comparison = 2
      } else {
        if (a.created_at > b.created_at) {
          comparison = -1
        } else if (a.created_at < b.created_at) {
          comparison = 1
        } else {
          comparison = 0
        }
      }
      return comparison
    },
    onRemovePC(item) {
      this.increment++
      this.lstPCs.splice(this.lstPCs.findIndex(function(obj) { return obj.user_id === item.user_id && obj.pc_id === item.pc_id }), 1)
      this.sortRefresh()
    },
    resetPopover(itemActive, isPopover) {
      this.increment++
      this.keyActive = itemActive
      this.keyPopover = isPopover
    }
  },
  watch: {
    '$route' (to, from) {
      if (to !== from) {
        this.autoRefresh()
      }
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .box_header{
    label.title{text-align: left; font-size:20px;font-weight:bold;font-family: 'adobe-clean', sans-serif;letter-spacing: 0px;color: #5F6468;display:inline-block
    }
  }
  .box-classes-me{ background: transparent; box-shadow: none;
    .box-info-pc{ padding-bottom: 15px; margin-bottom: 15px; border-bottom: 1px solid #B4B4B4;
      &:last-child{border: 0 none; padding-bottom: 0; margin-bottom: 0;}
    }
  }
  .box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media screen and (max-width: 768px){
  
}
@media screen and (min-width: 768px){
  
}
@media screen and (max-width: 768px){
  
}
</style>



// WEBPACK FOOTER //
// index.vue?937563fa